var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextDocumentsLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2940 3247",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M575 1660c-42 0-77-38-77-84 0-47 34-84 77-84h658c42 0 77 38 77 84 0 47-34 84-77 84H575zM2467 512h276c54 0 104 22 139 58 36 36 58 85 58 139v2342c0 54-22 104-58 139-36 36-85 58-139 58H670c-54 0-104-22-139-58-36-36-58-85-58-139v-314H197c-54 0-104-22-139-58-36-36-58-85-58-139V198C0 144 22 94 58 59 94 23 143 1 197 1h2073c54 0 104 22 139 58 36 36 58 85 58 139v314zM641 2737v314c0 8 3 15 8 20s12 8 20 8h2073c8 0 15-3 20-8s8-12 8-20V709c0-8-3-15-8-20s-12-8-20-8h-276v1859c0 54-22 104-58 139-36 36-85 58-139 58H641zM2269 170H196c-8 0-15 3-20 8s-8 12-8 20v2342c0 8 3 15 8 20s12 8 20 8h2073c8 0 15-3 20-8s8-12 8-20V198c0-8-3-15-8-20s-12-8-20-8zM574 758c-42 0-77-38-77-84 0-47 34-84 77-84h1316c42 0 77 38 77 84 0 47-34 84-77 84H574zm0 451c-42 0-77-38-77-84 0-47 34-84 77-84h1316c42 0 77 38 77 84 0 47-34 84-77 84H574z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDocumentsLine);
export default __webpack_public_path__ + "static/media/text-documents-line.c80a4a3c04a7cf63945087c5e2b5d617.svg";
export { ForwardRef as ReactComponent };